import React from 'react';
import { Button, Radio } from '@ntuctech/tangram-web';
import styled from 'styled-components';

import { fetcherApiRoute } from '../../../services/api/fetcher';

import {
  getInitialValueForFormGroup,
  marriageStatusMapping,
  updateMiCallbackUiAfterSave,
} from './helperFunction';

const ButtonSc = styled(Button)`
  width: 100%;
  margin-top: 100%;
`;

const MarriageRadio = ({
  keyValue,
  myinfoData,
  setMyinfoData,
  handleCloseSideSheet,
  setEditableFlowError,
  setShowToast,
  isPersonaEnabled,
  flowType,
  isMyinfoFapiEnabled,
}) => {
  const initialStatus = getInitialValueForFormGroup(myinfoData.data, keyValue);
  const [value, setValue] = React.useState(initialStatus);
  const handleSave = async () => {
    const mappedValue = marriageStatusMapping[value];

    /* eslint-disable indent */
    const apiConfig =
      flowType === 'myinfo'
        ? {
            url: '/api/v2/myinfo-signup-data',
            method: 'PATCH',
            body: {
              marital: mappedValue,
              field: keyValue,
              session_id: myinfoData.session_id,
            },
          }
        : {
            url: isMyinfoFapiEnabled
              ? '/api/v2/myinfo-personaldetails-fapi'
              : isPersonaEnabled
              ? '/api/v2/myinfo-update-personaldetails'
              : '/api/myinfo-update-personaldetails',
            method: 'POST',
            body: {
              value: mappedValue,
              field: keyValue,
              sessionId: myinfoData.session_id,
            },
          };
    /* eslint-enable indent */

    try {
      await fetcherApiRoute(apiConfig.url, {
        method: apiConfig.method,
        body: JSON.stringify(apiConfig.body),
      });

      updateMiCallbackUiAfterSave({
        myinfoData,
        setMyinfoData,
        newValue: value,
        key: keyValue,
        handleCloseSideSheet,
        setShowToast,
      });
    } catch (error) {
      setEditableFlowError(true);
    }
  };

  return (
    <div>
      <Radio.Group orientation="vertical" defaultValue={initialStatus} onValueChange={setValue}>
        <Radio value="Single">Single</Radio>
        <Radio value="Married">Married</Radio>
        <Radio value="Widowed">Widowed</Radio>
        <Radio value="Divorce">Divorce</Radio>
      </Radio.Group>
      <ButtonSc variant="primary" onClick={handleSave}>
        Save
      </ButtonSc>
    </div>
  );
};

export default MarriageRadio;
